/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProposedEdit = {
    created_on: string;
    created_by: string | null;
    id: string;
    table_name: string;
    action: ProposedEdit.action;
    data: string;
    where_clause: string | null;
};
export namespace ProposedEdit {
    export enum action {
        INSERT = 'insert',
        UPDATE = 'update',
        DELETE = 'delete',
    }
}

